module.exports = __webpack_public_path__ + "static/media/core diasco 90.89670890.png";